import React, { useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";

const ChatInput = ({ sideMenuVisible, input, setInput, handleSubmit, isLoading }) => {
    const { t } = useTranslation();

    const textareaRef = useRef(null);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleSubmit(event);
        }
    };

    useEffect(() => {
        const textarea = textareaRef.current;
        textarea.style.height = 'auto';
        textarea.style.height = `${Math.min(textarea.scrollHeight, 140)}px`;
    }, [input]);
    
    return (
        <div className={`chat-input-holder ${sideMenuVisible ? 'with-side-menu' : ''}`}>
            <form onSubmit={handleSubmit} className="chat-input-form">
                <textarea
                    ref={textareaRef}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className={`chat-input-textarea ${isLoading ? 'disabled' : ''}`}
                    placeholder={t("message_placeholder")}
                    disabled={isLoading}
                    rows={1}
                    style={{ resize: 'none', overflowY: 'auto' }}
                />
                {!isLoading && (
                    <button type="submit" id="send-button" className="submit-button">
                        {t('send')}
                    </button>
                )}
                {isLoading && <div className="spinner"></div>}
            </form>
        </div>
    );
};

export default ChatInput;